<div
  class="stat"
>
  <motn-stat-string
    [datum]="unackedCount.toLocaleString()"
    [color]="unackedCount ? 'red' : 'green'"
    [title]="'Unacknowledged Alarms'"
    [icon]="'bell-on'"
  ></motn-stat-string>

  <motn-stat-string
    [datum]="ackedCount.toLocaleString()"
    [color]="ackedCount ? 'yellow' : 'green'"
    [title]="'Acknowledged Alarms'"
    [icon]="'bell'"
  ></motn-stat-string>
</div>

@if (loading) {
  <motn-spinner [centered]="true"></motn-spinner>
}

@if (!loading && totalCount) {
  <motn-sort-table
    [table$]="table$"
  ></motn-sort-table>
}

@if (!loading && totalCount === 0) {
  <div class="empty-state">
    <i class="fa-regular fa-bell-slash"></i>
    <p>No active alarms</p>
  </div>
}
